let commonValues = {
    //"redeemPeriod": {
    //    "kr": "쿠폰 사용 기간",
    //    "en": "CODE REDEEM PERIOD",
    //    "de": "CODE-EINLÖSUNGSZEITRAUM",
    //    "fr": "PÉRIODE D'ÉCHANGE DU CODE",
    //    "es": "PERÍODO DE RESCATE DEL CÓDIGO",
    //    "pt": "PERÍODO DE RESGATE DO CÓDIGO",
    //    "ru": "ПЕРИОД ПОГАШЕНИЯ КОДА",
    //    "th": "ช่วงเวลาใช้งานไอเท็มโค้ด",
    //    "jp": "クーポン使用期限",
    //    "tw": "兌換碼使用期限",
    //    "id": "PERIODE REDEEM CODE"
    //},
    //"rewardCode": {
    //"kr": "보상 코드",
    //"en": "REWARD CODE",
    //"de": "BELOHNUNGSCODE",
    //"fr": "CODE DE RÉCOMPENSE",
    //"es": "CÓDIGO DE RECOMPENSA",
    //"pt": "CÓDIGO DE RECOMPENSA",
    //"ru": "КОД НАГРАДЫ",
    //"th": "โค้ดรางวัลของท่านคือ",
    //"jp": "報酬コード",
    //"tw": "獎勵兌換碼",
    //"id": "Kode Hadiah"
        //},
    "youtubeIds": {
        "en": "cxPPfnfh7wI",
        "de": "cxPPfnfh7wI",
        // "es": "JcpOK5mJh2o", // 
        "fr": "cxPPfnfh7wI",
        "jp": "z9dFO96645I", //
        "pt": "lHhNLQ9IjWI", // 
        // "ru": "fPb4GGGpkNk",
        "th": "cxPPfnfh7wI",
        "tw": "19aWtv-tgi4", //
        "id": "cxPPfnfh7wI",
    },
    "language": {
        "en": "English",
        "de": "Deutsch",
        // "es": "Español",
        "fr": "Francais",
        "jp": "日本語",
        "pt": "Português",
        // "ru": "Русский",
        "th": "ไทย",
        "tw": "臺灣",
    },
    "privacy": {
        "kr": "대한민국",
        "en": "Privacy Policy",
        "de": "Datenschutzrichtlinie",
        "es": "Política de privacidad",
        "fr": "Politique de confidentialité",
        "jp": "個人情報保護方針",
        "pt": "Política de Privacidade",
        "ru": "политика конфиденциальности",
        "th": "นโยบายส่วนบุคคล",
        "tw": "個人情報政策",
    },
    "service": {
        "kr": "대한민국",
        "en": "Terms of Service",
        "de": "Nutzungsbedingungen",
        "es": "Condiciones del servicio",
        "fr": "Conditions d'utilisation",
        "jp": "利用規約",
        "pt": "Termos de Uso",
        "ru": "Условия эксплуатации",
        "th": "เงื่อนไขการให้บริการ",
        "tw": "伺服器條款",
    },
    //2022-06-23 update
    //2022-06-24 update
    "link_copyed_txt": {
        "kr": "Link Copied!",
        "en": "Link Copied!",
        "de": "Link kopiert!",
        "fr": "Lien copié !",
        "es": "¡Link Copiado!",
        "pt": "Link Copiado!",
        "ru": "Скопировано!",
        "th": "คัดลอกลิงค์เรียบร้อย!",
        "jp": "コピー完了",
        "tw": "已複製連結",
        "id": "Copied!"
    },
    "success_pre_msg": { "kr": "사전예약이 완료되었습니다. 이메일 수신함을 확인해주세요.", "en": "Pre-Registration has been successful. Please check your email inbox.", "de": "Die Vorregistrierung war erfolgreich. Bitte überprüfe dein E-Mail-Postfach.", "fr": "Le pré-enregistrement a été effectuée avec succès. Veuillez vérifier votre boîte de réception.", "es": "La Preinscripción fue hecha con éxito. Por favor verifica tu buzón.", "pt": "O pré-registro foi feito com sucesso. Por favor, verifique seu e-mail.", "ru": "Пре-регистрация прошла успешно. Пожалуйста, проверьте свою почту.", "th": "ลงทะเบียนล่วงหน้าเรียบร้อยแล้ว ของรางวัลจะถูกส่งไปยังอีเมล์ของท่าน", "jp": "事前登録が完了しました。Eメールをご確認ください。", "tw": "事前預約成功，請查看電子郵件收件匣。", "id": "Pra-Registrasi telah berhasil. Silakan periksa email kamu." },
    "success_share_msg": {
        "kr": "공유 링크가 저장되었습니다.",
        "en": "Your shared link has been submitted.",
        "de": "Dein geteilter Link wurde übermittelt.",
        "fr": "Votre lien de partage a été enregistré. ",
        "es": "Tu link de comparte fue entregue.",
        "pt": "O link de seu compartilhamento foi salvo.",
        "ru": "Вам предоставлена ссылка для освещения.",
        "th": "ลงทะเบียนลิงค์เรียบร้อย",
        "jp": "共有URLを保存しました。",
        "tw": "分享連結儲存完畢。",
        "id": "Your shared link has been submitted."
    },
    //2022-06-24 update: en
    "preview_txt": {
        "kr": "미리보기",
        "en": "PREVIEW",
        "de": "VORSCHAU",
        "fr": "APERÇU",
        "es": "PREVIA",
        "pt": "PRÉVIA",
        "ru": "ПРЕВЬЮ",
        "th": "พรีวิวตัวละคร",
        "jp": "プレビュー",
        "tw": "預覽"
    },
    "server_txt": { "kr": "서버", "en": "SERVER", "de": "SERVER", "fr": "SERVEUR", "es": "SERVIDOR", "pt": "SERVIDOR", "ru": "СЕРВЕР", "th": "เซิร์ฟเวอร์", "jp": "サーバー", "tw": "伺服器", "id": "SERVER" },
    "email_address_txt": { "kr": "이메일 주소", "en": "EMAIL ADDRESS", "de": "E-MAIL-ADRESSE", "fr": "ADRESSE E-MAIL", "es": "CORREO ELECTRÓNICO", "pt": "EMAIL", "ru": "АДРЕС ПОЧТЫ", "th": "อีเมล์", "jp": "Eメールアドレス", "tw": "E-mail地址", "id": "EMAIL" },
    "game_no_txt": { "kr": "GAME MEMBERSHIP NO.", "en": "GAME MEMBERSHIP NO.", "de": "Spiel-Mitgliedsnummer", "fr": "NUMÉRO D'UTILISATEUR EN JEU", "es": "Nº DE REGISTRO DE JUGADOR", "pt": "Nº DE REGISTRO DE JOGADOR", "ru": "НОМЕР ЧЛЕНСТВА", "th": "หมายเลขสมาชิกเกม", "jp": "会員番号", "tw": "遊戲會員編號", "id": "GAME MEMBERSHIP NO." },
    //2022-06-23 update
    //2022-06-24 update
    "posting_url_txt": { "kr": "POSTING URL", "en": "POSTING URL", "de": "POSTING-URL", "fr": "URL DE PUBLICATION", "es": "URL DEL POST", "pt": "URL DO POST", "ru": "ПОСТ ССЫЛКИ", "th": "ลิงค์โพสต์", "jp": "掲載URL", "tw": "貼上連結", "id": "URL POSTING" },
    "submit_txt": { "kr": "제출", "en": "SUBMIT", "de": "SENDEN", "fr": "SOUMETTRE", "es": "ENVIAR", "pt": "ENVIAR", "ru": "ОТПРАВИТЬ", "th": "ลงทะเบียน", "jp": "提出", "tw": "提交", "id": "KIRIM" },
    "login_now_txt": {
        "kr": "지금 로그인",
        "en": "LOGIN NOW",
        "de": "JETZT EINLOGGEN",
        "fr": "CONNECTEZ-VOUS MAINTENANT",
        "es": "CONÉCTATE AHORA",
        "pt": "CONECTE-SE AGORA",
        "ru": "ЗАХОДИТЕ СЕЙЧАС",
        "th": "เข้าเกมเลย",
        "jp": "今すぐログイン",
        "tw": "立即登入遊戲"
    },
    "play_now_txt": {
        "kr": "지금 플레이하기",
        "en": "PLAY NOW",
        "de": "JETZT SPIELEN",
        "fr": "JOUEZ MAINTENANT",
        "es": "JUEGA AHORA",
        "pt": "JOGUE AGORA",
        "ru": "ИГРАЙТЕ УЖЕ СЕЙЧАС",
        "th": "เข้าเล่นเกมกันเถอะ!",
        "jp": "今すぐプレイ",
        "tw": "立即進行遊戲"
    }
}

export { commonValues }